import { Pipe, PipeTransform } from "@angular/core";
import { isDefined } from "@recursyve/nice-ts-utils";
import { sanitizeDirectusObject } from "../../../../../../../common/utils/sanitize-directus-object";
import { ItemsCoords } from "../../../../../../api/packbo/models/items-coords";
import { ItemsSuppliers } from "../../../../../../api/packbo/models/items-suppliers";

@Pipe({
    name: "sanitizeSupplierCoord"
})
export class SanitizeSupplierCoordPipe implements PipeTransform {
    public transform(suppliers: ItemsSuppliers): ItemsCoords | null {
        const sanitize = sanitizeDirectusObject(suppliers.coord_ref);

        if (isDefined(sanitize)) {
            return sanitize;
        }

        return null;
    }
}
